var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiniLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.498,
    height: 15.281,
    viewBox: "0 0 15.498 15.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(-545.829 -4185.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M34.939,32.63a1.652,1.652,0,0,1-1.788,1.657,1.66,1.66,0,1,1,1.788-1.657m-3.422,2.965h3.314v10.66H31.517Z",
    transform: "translate(514.399 4154.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M68.494,65.2c0-1.33-.044-2.441-.087-3.4h2.877l.153,1.482H71.5a3.828,3.828,0,0,1,3.292-1.722c2.18,0,3.815,1.461,3.815,4.6v6.3H75.3V66.552c0-1.373-.48-2.311-1.679-2.311a1.82,1.82,0,0,0-1.7,1.242,2.389,2.389,0,0,0-.109.829V72.46H68.494Z",
    transform: "translate(482.718 4128.377)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLinkedin);
export default __webpack_public_path__ + "static/media/mini-linkedin.b064e2202e143929d4cb01038d8e19e5.svg";
export { ForwardRef as ReactComponent };